{
    "ENERIX_CONTROL": {
        "LEGEND_DESCRIPTION": "Legende Betriebszustand"
    }
}
